import React, { useContext } from 'react';
import { CONTENT_MAPPING, PLAY_VIDEO_IN_SEQUENCE_KEY } from '../../../../../core/constants';
import CustomVideoMode from './CustomVideoMode/CustomVideoMode';
import YouTubeVideoMode from './YouTubeVideoMode';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';

//mui imports====
import { Box } from '@mui/system';
import GeneralTab from '../../../../../Components/GeneralTabAndTabContent';
import useCommonStyles from '../../../../../commonStyles';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import { Divider, Paper, Grid } from '@mui/material';
import CheckBoxInput from '../../../../../Components/CheckBoxInput';
import InputConfig from '../../../../../Components/InputConfig';
import PageHeading from '../../../../../Components/PageHeading';

const { CUSTOM_VIDEOS, YOUTUBE_VIDEOS } = CONTENT_MAPPING.VIDEO_CONTENT_MODES;
const { VIDEO_CONFIG_CUSTOM, VIDEO_CONFIG_YOUTUBE } = CONTENT_MAPPING.VIDEO_CONFIG_IDENTIFIERS;

const VideosConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	const tabListAndPanels = [
		{
			tab: <Tab label={CUSTOM_VIDEOS} value={VIDEO_CONFIG_CUSTOM} />,
			tabPanel: (
				<TabPanel
					value={VIDEO_CONFIG_CUSTOM}
					key={VIDEO_CONFIG_CUSTOM}
					sx={{ padding: 0, marginTop: '1.5rem' }}
				>
					<CustomVideoMode keyData={keyData} />
				</TabPanel>
			)
		},
		{
			tab: <Tab label={YOUTUBE_VIDEOS} value={VIDEO_CONFIG_YOUTUBE} />,
			tabPanel: (
				<TabPanel
					value={VIDEO_CONFIG_YOUTUBE}
					key={VIDEO_CONFIG_YOUTUBE}
					sx={{ padding: 0, marginTop: '1.5rem' }}
				>
					<YouTubeVideoMode keyData={'mappedPlaylistData'} />
				</TabPanel>
			)
		}
	];

	return (
		<Box style={{ height: 'fit-content', padding: '2rem' }}>
			<Paper
				sx={{ paddingBottom: '2rem', margin: '1rem' }}
				className={commonStyleClasses.mainPagePaperMarginStyle}
			>
				<PageHeading headingName="Videos" showInfoButton={true} infoMessage={featureDescription} />

				<Grid container spacing={3}>
					<Grid item xs={3}>
						<CheckBoxInput
							containerStyles={{
								marginTop: '4rem',
								marginLeft: '5rem',
								width: 'fit-content'
							}}
							keyData={PLAY_VIDEO_IN_SEQUENCE_KEY}
							label="Play Videos In Sequence"
							object={rawConfig}
							isObjectEditor={true}
							updateObject={updateRawConfig}
						/>
					</Grid>
					<Grid item xs={3}>
						<InputConfig
							keyData="sectionLvlCtaDetails.ctaText"
							object={rawConfig}
							updateObject={updateRawConfig}
							label="Section Cta Text"
						/>
					</Grid>
					<Grid item xs={3}>
						<InputConfig
							keyData="sectionLvlCtaDetails.ctaUrl"
							object={rawConfig}
							updateObject={updateRawConfig}
							label="Section Cta Url"
						/>
					</Grid>
				</Grid>
				<Divider
					style={{ width: '95%', margin: '0 auto', marginBottom: '8rem', marginTop: '3rem' }}
				/>

				<GeneralTab
					tabListAndPanels={tabListAndPanels}
					tabListStyles={{ width: 'fit-content', margin: '0 auto' }}
				/>
			</Paper>
		</Box>
	);
};

export default VideosConfig;
